<template>

    <div class="room-panel" style="z-index:10;" ref="panelRef">

        <div class="has-shadow panel panel--primary mb-4">
            <div class="row">
                <div class="col-xl-18">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="room-gallery">
                                <single-image-gallery v-bind:images="roomType.Images"></single-image-gallery>
                            </div>
                        </div>
                        <div class="col-md-12 room-info">
                            <h3 class="title">{{roomType.DisplayName}}</h3>
                            <div class="description" v-bind:class="{'expanded': expanded}" v-html="roomType.Description"></div>


                            <button class="expander" v-on:click="expanded = !expanded">{{expanded ? "Hide" : "View more"}}</button>


                            <div class="features-container">

                                <span class="feature-item feature-item--room">Avg. {{roomType.RoomSize}} sq. m</span>
                                <span class="feature-item  feature-item--bed">{{roomType.BedType}}</span>
                                <span v-if="roomType.IsDogFriendly" class="feature-item feature-item--dog">Dog Friendly</span>


                                <span class="feature-item  feature-item--occupancy">
                                    {{roomType.MaxAdults}}  {{roomType.MaxAdults == 1 ? "adult" : "adults"}}<text>/</text> {{roomType.MaxChildren}} {{roomType.MaxChildren == 1 ? "child" : "children" }}
                                </span>

                            </div>

                        </div>
                    </div>
                </div>

                <div class="d-none d-xl-flex col-xl-6">

                    <div class="pricing-panel h-100 w-100">

                        <div v-if="!supportsGuestCount"
                             class="p-3 text-center d-flex flex-column justify-content-center h-100 ">
                            <span class="sold-out">
                                Requires a minimum of {{roomType.MinOccupancy}} guests
                            </span>
                        </div>

                        <div v-else-if="requiresDog && !roomSupportsDog && filteredUnitsAvailable > 0"
                             class="p-3 text-center d-flex flex-column justify-content-center h-100 ">
                            <span class="sold-out">Not dog friendly</span>
                        </div>

                        <div v-else-if="requiresChild && !roomSupportsChild && filteredUnitsAvailable > 0"
                             class="p-3 text-center d-flex flex-column justify-content-center h-100 ">
                            <span class="sold-out">Not child friendly</span>
                        </div>

                        <div v-else-if="requiresBaby && !roomSupportsInfant && filteredUnitsAvailable > 0"
                             class="p-3 text-center d-flex flex-column justify-content-center h-100 ">
                            <span class="sold-out">Not infant friendly</span>
                        </div>

                        <div v-else-if="filteredUnitsAvailable > 0"
                             class="p-3 text-center d-flex flex-column justify-content-center h-100">

                            <div class="row">
                                <span class="total-label">From</span>
                                <span class="total-amount ">&pound;{{totalAmount(fromRate)}}</span>

                                <span>For {{search.numberOfNights == 1 ? '1 night' : search.numberOfNights + ' nights'}}<br />{{fromRate.description != undefined ? fromRate.description.DisplayName : ( fromRate.availability.Description ?? fromRate.availability.Name )}}</span>
                            </div>
                        </div>
                        <div v-else
                             class="p-3 text-center d-flex flex-column justify-content-center h-100 ">

                            <span class="sold-out">No Availability</span>
                            <span v-if="arrivalMlos" class="mlos-notice">Minimum {{ arrivalMlos }}-night stay required</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row ">
                <div class="d-none d-md-flex col-md-24 col-xl-18 g-0">

                    <room-calendar v-if="isCalendarVisible"
                                   v-bind:roomType="roomType"
                                   v-bind:leg="leg"></room-calendar>

                </div>
                <div class="col-24 col-xl-6">
                    <div class="row h-100">
                        <div class="col-24 col-md-16  d-xl-none">
                            <div class="pricing-panel pricing-panel--m h-100">

                                <div v-if=" requiresDog && !roomSupportsDog "
                                     class="p-3 text-center d-flex flex-column justify-content-center h-100 ">
                                    <span class="sold-out">Not dog friendly</span>
                                </div>

                                <div v-else-if="requiresChild && !roomSupportsChild && filteredUnitsAvailable > 0"
                                     class="p-3 text-center d-flex flex-column justify-content-center h-100 ">
                                    <span class="sold-out">Not child friendly</span>
                                </div>

                                <div v-else-if="requiresBaby && !roomSupportsInfant && filteredUnitsAvailable > 0"
                                     class="p-3 text-center d-flex flex-column justify-content-center h-100 ">
                                    <span class="sold-out">Not infant friendly</span>
                                </div>




                                <div v-else-if="filteredUnitsAvailable > 0"
                                     class="px-2 py-2 d-flex flex-row align-items-end h-100">
                                    <div class="row ">


                                        <div class="col-14">
                                            <span class="">For {{search.numberOfNights == 1 ? '1 night' : search.numberOfNights + ' nights'}} {{fromRate.description != undefined ? fromRate.description.DisplayName : ( fromRate.availability.Description ?? fromRate.availability.Name )}}</span>
                                        </div>

                                        <div class="col-10  d-flex flex-column">
                                            <span class="total-label ">From</span>


                                            <span class="total-amount ">&pound;{{totalAmount(fromRate)}}</span>

                                        </div>
                                    </div>


                                </div>
                                <div v-else-if="filteredUnitsAvailable <= 0"
                                     class="px-5 py-3  text-center d-flex flex-column justify-content-center h-100">
                                    <span class="sold-out">Sold out</span>
                                    <span v-if="arrivalMlos" class="mlos-notice">Minimum {{ arrivalMlos }}-night stay required</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-24 col-md-8 col-xl-24 ">
                            <button class="btn btn--slate-blue btn--continue btn--block px-0 h-100"
                                    v-bind:disabled="(filteredUnitsAvailable <= 0) || (requiresDog  &&  (!roomSupportsDog || !hasEnoughDogs)) || (requiresChild && (!roomSupportsChild || !hasEnoughChildren)) || (requiresBaby && (!roomSupportsInfant || !hasEnoughInfants))"
                                    v-on:click="onSelectRoom(roomType)">

                                Continue
                            </button>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import SingleImageGallery from '@/shared/components/SingleImageGallery.vue';

    import RoomCalendar from '../components/RoomCalendar.vue';

    import { store } from '../store/index';
    import { _ } from 'vue-underscore';
    import moment from 'moment';

    export default {
        name: 'RoomPanel',
        props: {
            leg: String,
            roomType: Object,
            requiresDogButNone: Boolean
        },
        computed: {
            booking() {
                return store.getters.booking;
            },
            session() {
                return store.getters.session
            },
            search() {
                return store.getters.search;
            },
            supportsGuestCount() {
                let go = this.search.guestOccupancies[+(this.leg) - 1];

                return (go.adults + go.children.length) >= this.roomType.MinOccupancy;
            },
            requiresDog() {
                return this.search.guestOccupancies[+(this.leg) - 1].dogs > 0;
            },
            requiresChild() {
                return this.search.guestOccupancies[+(this.leg) - 1].children?.filter(item => item.age >= 4).length ?? 0;
            },
            requiresBaby() {
                return this.search.guestOccupancies[+(this.leg) - 1].children?.filter(item => item.age <= 3).length ?? 0;
            },
            roomSupportsDog() {
                return this.roomType.IsDogFriendly
            },

            roomSupportsChild() {
                return this.roomType.IsChildFriendly
            },

            roomSupportsInfant() {
                return this.roomType.IsInfantFriendly
            },

            canSelectDog() {

                return this.requiresDog && this.roomSupportsDog;
            },
            dogPackage() {
                let dogAvailability = this.roomAvailability.Packages.find(item => item.Code == "DOG");
                return dogAvailability;
            },
            childPackage() {
                let childAvailability = this.roomAvailability.Packages.find(item => item.Code == "CHILD");

                console.log("childPackage()", childAvailability);

                return childAvailability;
            },
            infantPackage() {
                let infantAvailability = this.roomAvailability.Packages.find(item => item.Code == "BABY");

                console.log("infantPackage()", infantAvailability);

                return infantAvailability;
            },
            hasEnoughChildren() {
                let result = false;

                if (this.roomAvailability != undefined && this.roomAvailability.Packages.length) {
                    console.log("hasEnoughChildren()", this.roomAvailability);

                    let childrenAvailability = this.roomAvailability.Packages.find(item => item.Code == "CHILD");

                    if (childrenAvailability != null) {
                        result = childrenAvailability.QuantityRequired <= childrenAvailability.QuantityAvailable;
                    }
                }

                console.log("hasEnoughChildren()", result);

                return result;

            },
            hasEnoughInfants() {
                let result = false;

                if (this.roomAvailability != undefined && this.roomAvailability.Packages.length) {
                    console.log("hasEnoughInfants()", this.roomAvailability);

                    let babyAvailability = this.roomAvailability.Packages.find(item => item.Code == "BABY");

                    if (babyAvailability != null) {
                        result = babyAvailability.QuantityRequired <= babyAvailability.QuantityAvailable;
                    }
                }

                console.log("hasEnoughInfants()", result);

                return result;

            },

            hasEnoughDogs() {
                let result = false;

                if (this.roomAvailability != undefined && this.roomAvailability.Packages.length) {
                    let dogAvailability = this.roomAvailability.Packages.find(item => item.Code == "DOG");
                    if (dogAvailability != null) {
                        result = dogAvailability.QuantityRequired <= dogAvailability.QuantityAvailable;

                    }
                }

                return result;

            },
            roomAvailability() {

                let roomAvailability = store.getters.roomAvailability(this.leg, this.roomType.PMSCode);

                return roomAvailability;
            },
            allRates() {
                let configuration = store.getters.roomConfiguration;

                var rates = configuration.RateGroups.map(item => item.Rates);

                var allRates = [].concat(...rates);
                return allRates;
            },
            flatRates() {
                let configuration = store.getters.roomConfiguration;

                var rates = configuration.FlatRates;

                var allRates = [].concat(...rates);
                return allRates;
            },
            fromRate() {
                if (this.roomAvailability != null) {

                    if (this.roomAvailability.Rates != null && this.roomAvailability.Rates.length) {

                        let sorted = _.sortBy(this.roomAvailability.Rates, function (a) {
                            return a.Amount;
                        })


                        let rate = sorted[0];

                        var thisRate = this.allRates.find(item => item.PMSCode == rate.RateCode);

                        if (thisRate == null) {
                            thisRate = this.flatRates.find(item => item.PMSCode == rate.RateCode);
                        }

                        return {
                            availability: rate,
                            description: thisRate
                        }
                    }

                }

                return null;
            },

            arrivalMlos() {
                const roomCalendar = store.getters.roomCalendar(this.roomType.PMSCode);
                if (!roomCalendar) return null;
                const arrivalDate = moment(this.search.arrivalDate);
                const arrival = roomCalendar.find(d => moment(d.Date).isSame(arrivalDate, 'day'));
                return (arrival && arrival.MinLengthOfStay > 1) ? arrival.MinLengthOfStay : null;
            },
            filteredUnitsAvailable() {
                if (this.roomAvailability != null) {
                    let guestOccupancy = this.search.guestOccupancies[(+this.leg) - 1];

                    //Check guest occupancies;
                    let maxAdults = this.roomType.maxAdults;
                    let maxChildren = this.roomType.maxChildren;
                    let maxOccupancy = this.roomType.maxOccupancy;

                    let totalGuests = guestOccupancy.adults + guestOccupancy.childCount;

                    if (totalGuests > maxOccupancy || maxAdults > guestOccupancy.adults || maxChildren > guestOccupancy.childCount) {
                        return 0;
                    }


                    let booking = this.booking;
                    if (booking != null) {

                        var bookedRoomCodes = this.booking.legs.map(item => item.room.PMSCode);
                        var counts = _.countBy(bookedRoomCodes, function (item) { return item; });
                        var thisCount = counts[this.roomAvailability.Room.Code];
                        if (thisCount != undefined) {

                            return this.roomAvailability.Room.UnitsAvailable - (+thisCount);
                        }

                    }

                    return this.roomAvailability.Room.UnitsAvailable;
                }
                return 0;
            }
        },
        components: {

            SingleImageGallery,
            RoomCalendar
        },
        data() {
            return {
                expanded: false,
                loading: true,
                isCalendarVisible: false
            }
        },
        mounted() {
            this._observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting) {
                        this.isCalendarVisible = true;
                        this._observer.disconnect();
                    }
                },
                { rootMargin: '200px' }
            );

            this._observer.observe(this.$refs.panelRef);
        },
        beforeUnmount() {
            if (this._observer) {
                this._observer.disconnect();
            }
        },
        methods: {
            onSelectRoom: function (room) {
                let includedPackages = [];

                if (this.requiresDog) {
                    includedPackages.push(this.dogPackage);
                }
                if (this.requiresChild) {
                    includedPackages.push(this.childPackage);
                }
                if (this.requiresBaby) {
                    includedPackages.push(this.infantPackage);
                }

                //GTM tracking
                this.track();

                let payload = {
                    leg: this.leg,
                    room,
                    packages: includedPackages
                }
                store.dispatch("selectRoom", payload);


                this.$router.push({ name: 'stay_leg_room_rates', params: { id: this.session.Id, leg: this.leg } });
            },
            totalAmount(rate) {

                let result = rate.availability.Amount

                return this.priceFormatted(result);
            },

            priceFormatted(num) {
                if (num % 1 == 0) {
                    return num;
                }

                return num.toFixed(2);
            },

            track() {

                if (this.$gtm.enabled()) {

                    window.dataLayer?.push({
                        'pageURL': '/stay/room/',
                        'event': 'view_item',
                        'leg': this.leg,
                        'room': this.roomType.DisplayName
                    });
                }
            },

        },




    }
</script>